import styles from './Primitives.module.scss';
import { FlexIcon } from './FlexIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TpFancyButtonProps {
  iconName: string;
  children: React.ReactNode;
  darkBackground?: boolean;
  large?: boolean;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const FancyButton = ({ iconName, children, large, onClick, disabled, isLoading }: TpFancyButtonProps) => {
  return (
    <button
      className={large ? styles.fancyButtonWhiteBackgroundLarge : styles.fancyButtonWhiteBackground}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.fancyButtonWhiteBackgroundLeftShadow} />
      <div className={styles.fancyButtonWhiteBackgroundRightShadow} />
      <div className={styles.fancyButtonWhiteBackgroundContent}>
        <div className={styles.fancyButtonIcon}>
          {isLoading ? <FontAwesomeIcon icon={['fas', 'spinner']} spin /> : <FlexIcon iconName={iconName} />}
        </div>
        <div className={styles.buttonContent}>{children}</div>
      </div>
    </button>
  );
};
